import React from 'react';
import { classnames } from 'helpers/utils';
import { Checkbox } from 'common/checkbox';
import styles from './topic-selector.module.scss';

type TopicSelectorProps = {
  suggestedQuestionsList: PreBuiltQuestionsType[];
  selected: PreBuiltQuestionsType[];
  toggleSelection: (data: PreBuiltQuestionsType) => void;
};

const TopicSelector: React.FC<TopicSelectorProps> = ({
  suggestedQuestionsList,
  selected,
  toggleSelection,
}) => (
  <div className={styles.grid}>
    {suggestedQuestionsList.map((topic) => (
      <button
        type="button"
        key={topic.id}
        className={classnames(
          styles.card,
          selected.includes(topic) ? styles.selected : '',
        )}
        onClick={() => toggleSelection(topic)}
      >
        <div className={styles.checkboxWrapper}>
          <Checkbox
            itemKey={topic.id}
            isChecked={selected.includes(topic)}
            onChange={() => toggleSelection(topic)}
          />
        </div>
        <div className={styles.labelWrapper}>
          <span className="text__body__bold__medium__gray800">
            {topic.name}
          </span>
        </div>
      </button>
    ))}
  </div>
);

export { TopicSelector };
